import type { OrderFailureReason } from '@/analytics';

/**
 * Map a Plaee order rejection `errorCode` (returned with `success: false` on an
 * otherwise-200 place/amend/cancel result) to the analytics failure-reason
 * vocabulary. Unrecognised codes fall back to `unknown`.
 */
export function toOrderFailureReason(errorCode?: string): OrderFailureReason {
  switch (errorCode) {
    case 'INSUFFICIENT_FUNDS':
      return 'insufficient_funds';
    case 'MARKET_CLOSED':
    case 'MARKET_HALTED':
    case 'MARKET_SETTLED':
    case 'EXCHANGE_CLOSED':
    case 'SESSION_DOWN':
      return 'market_closed';
    case 'INVALID_PRICE':
    case 'INVALID_PRICE_INCREMENT':
      return 'price_changed';
    default:
      return 'unknown';
  }
}

/** Player-facing message for a failed order, keyed by failure reason. */
export const ORDER_FAILURE_MESSAGE: Record<OrderFailureReason, string> = {
  network: 'Network error — please try again.',
  insufficient_funds: 'Not enough balance for this order.',
  kyc_required: 'Verification required before trading.',
  market_closed: 'This market is no longer open.',
  price_changed: 'The price moved — please try again.',
  unknown: "Couldn't place the order — please try again.",
};
